export class InternationalLocation {
    unitId: string;
    name: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    phone: string;

    constructor(init?: Partial<InternationalLocation>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): InternationalLocation {
        return new InternationalLocation(obj);
    }
}
